<div class="guitar-app-wrap">
  <h1>Guitar Learning App</h1>
  <nav class="guitar-nav">
    <a routerLink="/guitar-app/lessons">Lessons</a>
    <a routerLink="/guitar-app/visualizer">Fretboard Visualizer</a>
    <a routerLink="/guitar-app/chords">Chord Explorer</a>
    <a routerLink="/guitar-app/scales">Scale Explorer</a>
    <a routerLink="/guitar-app/progress">Progress Tracker</a>
  </nav>
  <div class="guitar-app-content">
    <router-outlet></router-outlet>
  </div>
</div>

